import { Input, InputRef, Popover } from 'antd';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import { BasicPhoneInputProps } from './phone-input.types';
import { PopoverCountriesList } from './popover-countries-list';
import { useBasicPhoneInput } from './use-basic-phone-input';

const BasicPhoneInput = forwardRef<InputRef, BasicPhoneInputProps>((props, ref) => {
  const {
    value,
    countryCode,
    bordered,
    placeholder,
    placement = 'bottom',
    rootClassName,
    size = 'large',
    suffix,
    onFocus,
    autoFocus = true,
  } = props;

  const {
    open,
    handleClose,
    handleOpenChange,
    handleChange,
    handleCountrySelect,
    selectedCountryFlag,
    getFlagClass,
    getFlagWrapperClass,
    getInputClass,
  } = useBasicPhoneInput(props);

  return (
    <div
      className={clsx(
        'flex max-w-full',
        // single className is over lengthy so breakdown into multiple chunks
        bordered && 'items-center rounded-lg overflow-hidden leading-10 pl-3.5 transition-all duration-300',
        bordered && 'border border-gray-600 hover:border-primary-500 focus-within:border-primary-500',
        bordered && 'focus-within:shadow-[0_0_0_2px_rgba(5,51,97,0.24)]',
        rootClassName
      )}
    >
      <Popover
        open={open}
        onOpenChange={handleOpenChange}
        content={
          <PopoverCountriesList
            countryCode={countryCode ?? ''}
            setDialingCode={handleCountrySelect}
            isPopoverOpen={open}
            closePopover={handleClose}
            bordered={bordered}
          />
        }
        trigger="click"
        rootClassName="[&_.ant-popover-inner]:p-0! max-w-64!"
        destroyOnHidden
        placement={placement}
      >
        <div className={getFlagWrapperClass()}>
          <div className={clsx('size-[27px] flex items-center', bordered ? 'justify-end' : 'justify-center')}>
            <img src={selectedCountryFlag} alt="" className={clsx('cursor-pointer', getFlagClass())} />
          </div>
          {size === 'large' && (
            <div
              className={clsx(
                'rounded-full pointer-events-none bg-surface flex items-center justify-center',
                !bordered && 'size-3.5 absolute -bottom-0.5 -right-0.5 border border-gray-300'
              )}
            >
              <RiArrowDownSLine className={clsx(bordered ? 'size-5' : 'size-3.5')} />
            </div>
          )}
        </div>
      </Popover>

      {bordered && <div className="border-r border-gray-600 h-5 ml-2"></div>}

      <Input
        style={{
          minWidth: '8ch',
          width: bordered ? 'full' : value.length + 3 + 'ch',
        }}
        className={getInputClass()}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        autoFocus={autoFocus}
        placeholder={placeholder}
        ref={ref}
      />
      {suffix && <div className="shrink-0 pr-3">{suffix}</div>}
    </div>
  );
});

export default BasicPhoneInput;
